export default (phone: string) => {
  if (phone) {
    const PHONE_REGEX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return phone.replace(PHONE_REGEX, '($1) $2-$3');
  }
  return phone;
};
